(function($) {
    $('.scroll-top').on('click', function(e) {
        e.preventDefault();
        $(window).scrollTo(0, 500, {duration: 500});
    });
})(jQuery);